import styled from "styled-components";
import { primaryColor } from "../../config/constants";

export const PageWrapper = styled.div`
  min-height: 100vh;
  padding: 30px 20px;
  max-width: 1100px;
  margin: 0 auto;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const UserInfo = styled.span`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
`;

export const RoleBadge = styled.span`
  margin-left: 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 0.75rem;
`;

export const GhostButton = styled.button`
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: transparent;
  color: #fff;
  font-size: 0.85rem;
  cursor: pointer;
`;

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const PageTitle = styled.h1`
  color: #fff;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
`;

export const PrimaryButton = styled.button`
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  background: ${primaryColor};
  color: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const DangerButton = styled.button`
  padding: 6px 14px;
  border-radius: 6px;
  border: none;
  background: #ff4d4d;
  color: #fff;
  font-size: 0.85rem;
  cursor: pointer;
`;

export const FormCard = styled.form`
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
`;

export const DateInput = styled.input`
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 0.9rem;
  outline: none;
  color-scheme: dark;
  min-width: 220px;

  &:focus {
    border-color: ${primaryColor};
  }
`;

export const ErrorMsg = styled.p`
  color: #ff6b6b;
  font-size: 0.85rem;
  margin: 0;
`;

export const EmptyState = styled.p`
  color: rgba(255, 255, 255, 0.4);
  text-align: center;
  padding: 40px 0;
`;

/* ---- Calendar ---- */

export const CalendarNav = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const NavButton = styled.button`
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: #fff;
  font-size: 1.1rem;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }
`;

export const MonthLabel = styled.span`
  color: #fff;
  font-size: 1.2rem;
  font-weight: 600;
  min-width: 200px;
  text-align: center;
  text-transform: capitalize;
`;

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  overflow: hidden;
`;

export const DayHeader = styled.div`
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  text-align: center;
  padding: 10px 4px;
  letter-spacing: 0.5px;
`;

export const DayCell = styled.div`
  background: ${({ $isToday }) =>
    $isToday ? "rgba(38, 169, 182, 0.1)" : "rgba(10, 10, 20, 0.5)"};
  min-height: 100px;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  position: relative;
  border: ${({ $isToday }) =>
    $isToday ? "1px solid rgba(38, 169, 182, 0.4)" : "1px solid transparent"};
  opacity: ${({ $outside }) => ($outside ? 0.3 : 1)};
`;

export const DayNumber = styled.span`
  color: ${({ $isToday }) => ($isToday ? primaryColor : "rgba(255,255,255,0.5)")};
  font-size: 0.75rem;
  font-weight: ${({ $isToday }) => ($isToday ? 700 : 400)};
  margin-bottom: 2px;
  text-align: right;
  padding-right: 4px;
`;

export const EventChip = styled.div`
  background: ${({ $color }) => $color}25;
  border-left: 3px solid ${({ $color }) => $color};
  color: #fff;
  font-size: 0.7rem;
  padding: 3px 6px;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background: ${({ $color }) => $color}44;
  }
`;

export const MoreChip = styled.div`
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.65rem;
  text-align: center;
  cursor: pointer;
  padding: 1px 0;

  &:hover {
    color: #fff;
  }
`;

/* ---- Detail Popup ---- */

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9000;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DetailCard = styled.div`
  background: rgba(20, 20, 30, 0.97);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 28px 32px;
  min-width: 320px;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.6);
`;

export const DetailTitle = styled.h3`
  color: #fff;
  margin: 0;
  font-size: 1.1rem;
`;

export const DetailRow = styled.div`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  background: ${({ color }) => color}22;
  color: ${({ color }) => color};
  border: 1px solid ${({ color }) => color}55;
`;

export const ActionRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 4px;
`;
